module.exports = __webpack_public_path__ + "media/images/countryrect/gb-1b8b7a09e08dc69b3b655de443703ec7.svg";